(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fasciapro-before-after"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fp-before-after]').forEach(function(slider){if(slider.dataset.ready)return;slider.dataset.ready='true';var after=slider.querySelector('.fp-before-after__after');var handle=slider.querySelector('.fp-before-after__handle');function setPosition(clientX){var rect=slider.getBoundingClientRect();var percent=Math.max(0,Math.min(100,(clientX-rect.left)/rect.width*100));after.style.clipPath='inset(0 0 0 '+percent+'%)';handle.style.left=percent+'%'}slider.addEventListener('pointerdown',function(event){setPosition(event.clientX);function move(moveEvent){setPosition(moveEvent.clientX)}document.addEventListener('pointermove',move);document.addEventListener('pointerup',function(){document.removeEventListener('pointermove',move)},{once:true})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fasciapro-media-rows"] && !Shopify.designMode) return;
  try {
    
function fpLoadRowVideo(video){if(video.dataset.fpLoaded)return;video.src=video.dataset.fpSrc;video.dataset.fpLoaded='true';video.load()}
function fpPrepareRowVideos(root){const videos=(root||document).querySelectorAll('.fp-media-rows video.fp-lazy-video:not([data-fp-observed])');if(!videos.length)return;videos.forEach(function(video){video.dataset.fpObserved='true'});if(!('IntersectionObserver'in window)){videos.forEach(function(video){fpLoadRowVideo(video);video.play().catch(function(){})});return}const loader=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){fpLoadRowVideo(entry.target);loader.unobserve(entry.target)}})},{rootMargin:'700px 0px'});const player=new IntersectionObserver(function(entries){entries.forEach(function(entry){const video=entry.target;if(entry.isIntersecting&&entry.intersectionRatio>=.25){fpLoadRowVideo(video);video.play().catch(function(){})}else{video.pause()}})},{threshold:[0,.25,.75]});videos.forEach(function(video){loader.observe(video);player.observe(video)})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){fpPrepareRowVideos(document)})}else{fpPrepareRowVideos(document)}
document.addEventListener('shopify:section:load',function(event){fpPrepareRowVideos(event.target)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fasciapro-product-enhancements"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.fp-product-enhancements').forEach(function(section){
  var productInfo=document.querySelector('[id^="ProductInfo-"]');
  var title=productInfo&&productInfo.querySelector('h1');
  if(title&&!productInfo.querySelector('.fp-product-rating')){
    var rating=document.createElement('div');
    rating.className='fp-product-rating';
    rating.innerHTML='<span class="fp-product-rating__stars"><span>★</span><span>★</span><span>★</span><span>★</span><span>★</span></span><span>'+section.dataset.ratingText+'</span>';
    title.parentNode.insertBefore(rating,title);
  }
  var upsell=section.querySelector('[data-recovery-upsell]');
  var mainButton=document.querySelector('[id^="ProductSubmitButton-"]');
  var productForm=mainButton&&mainButton.closest('form');
  if(upsell&&productForm&&upsell.querySelector('[data-recovery-variant]')){
    productForm.parentNode.insertBefore(upsell,productForm);
    productForm.addEventListener('submit',function(event){
      var selected=upsell.querySelectorAll('[data-recovery-variant]:checked');
      if(!selected.length)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var mainVariant=productForm.querySelector('[name="id"]');
      if(!mainVariant)return;
      var items=[{id:Number(mainVariant.value),quantity:1}];
      selected.forEach(function(input){items.push({id:Number(input.value),quantity:1});});
      mainButton.disabled=true;
      fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(response){if(!response.ok)throw new Error('Cart error');return response.json();})
        .then(function(){window.location.href=window.Shopify.routes.root+'cart';})
        .catch(function(){mainButton.disabled=false;});
    },true);
  }
  var sticky=section.querySelector('.fp-sticky-cart');
  var stickyButton=section.querySelector('.fp-sticky-cart__button');
  if(!sticky||!stickyButton||!mainButton)return;
  stickyButton.addEventListener('click',function(){mainButton.click();});
  var observer=new IntersectionObserver(function(entries){
    sticky.classList.toggle('is-visible',!entries[0].isIntersecting);
  },{threshold:0});
  observer.observe(mainButton);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fasciapro-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.fp-reviews--slider').forEach(function(section){
  var track=section.querySelector('.fp-reviews__grid');
  var prev=section.querySelector('.fp-reviews__prev');
  var next=section.querySelector('.fp-reviews__next');
  if(!track||!prev||!next)return;
  prev.addEventListener('click',function(){track.scrollBy({left:-track.clientWidth,behavior:'smooth'});});
  next.addEventListener('click',function(){track.scrollBy({left:track.clientWidth,behavior:'smooth'});});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fasciapro-video-gallery"] && !Shopify.designMode) return;
  try {
    
function fpLoadVideo(video){if(video.dataset.fpLoaded)return;video.src=video.dataset.fpSrc;video.dataset.fpLoaded='true';video.load()}
function fpPrepareVideos(root){const videos=(root||document).querySelectorAll('video.fp-lazy-video:not([data-fp-observed])');if(!videos.length)return;videos.forEach(function(video){video.dataset.fpObserved='true'});if(!('IntersectionObserver'in window)){videos.forEach(function(video){fpLoadVideo(video);video.play().catch(function(){})});return}const loader=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){fpLoadVideo(entry.target);loader.unobserve(entry.target)}})},{rootMargin:'700px 0px'});const player=new IntersectionObserver(function(entries){entries.forEach(function(entry){const video=entry.target;if(entry.isIntersecting&&entry.intersectionRatio>=.25){fpLoadVideo(video);video.play().catch(function(){})}else{video.pause()}})},{threshold:[0,.25,.75]});videos.forEach(function(video){loader.observe(video);player.observe(video)})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){fpPrepareVideos(document)})}else{fpPrepareVideos(document)}
document.addEventListener('shopify:section:load',function(event){fpPrepareVideos(event.target)});
document.addEventListener('click',function(event){const button=event.target.closest('.fp-video-gallery__sound');const video=event.target.closest('.fp-video-gallery__card video');const control=button||video?.closest('.fp-video-gallery__card')?.querySelector('.fp-video-gallery__sound');if(!control)return;const card=control.closest('.fp-video-gallery__card');const media=card?.querySelector('video');if(!media)return;fpLoadVideo(media);document.querySelectorAll('.fp-video-gallery__card video').forEach(function(item){if(item!==media){item.muted=true;const other=item.closest('.fp-video-gallery__card')?.querySelector('.fp-video-gallery__sound');if(other){other.textContent='🔇';other.setAttribute('aria-label','Play video with sound')}}});media.muted=!media.muted;control.textContent=media.muted?'🔇':'🔊';control.setAttribute('aria-label',media.muted?'Play video with sound':'Mute video');if(media.paused)media.play().catch(function(){})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-matrix-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-review-page]');if(!button)return;const root=button.closest('.gmr');if(!root)return;const page=Number(button.dataset.reviewPage);root.querySelectorAll('[data-review-index]').forEach(function(card){const index=Number(card.dataset.reviewIndex);card.hidden=index<page*10||index>=(page+1)*10;});root.querySelectorAll('[data-review-page]').forEach(function(control){control.removeAttribute('aria-current');});button.setAttribute('aria-current','page');root.scrollIntoView({behavior:'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
